  import axios from 'axios';
  import {useState} from 'react';
  import {useEffect, FC} from 'react';
  import {Carousel} from 'react-responsive-carousel';
  import 'react-responsive-carousel/lib/styles/carousel.min.css';
  import { ChevronLeft, ChevronRight } from 'lucide-react';
  import {URLS} from '../../config';
  import {hooks} from '../../hooks';
  import {items} from '../../items';
  import {custom} from '../../custom';
  import {theme} from '../../constants';
  import {actions} from '../../store/actions';
  import {components} from '../../components';                                                                        

  



  export const Home: FC = () => {
    const dispatch = hooks.useAppDispatch();
    const navigate = hooks.useAppNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [activeIndex, setActiveIndex] = useState(0);

    const [productsData, setProductsData] = useState<any>([]);
    const [booksData, setBooksData] = useState<any>([]);

    const [bannersData, setBannersData] = useState<any>([]);
    const [carouselData, setCarouselData] = useState<any>([]);

      const isMobile = window.innerWidth <= 600;
    
  

    const getData = async () => {
      setLoading(true);

      try {
        const products = await axios
          .get(URLS.GET_PRODUCTS)
          .then(res => res.data.products);
          
        const books = await axios
          .get(URLS.GET_BOOKS)
          .then(res => res.data.books);

        const banners = await axios
          .get(URLS.GET_BANNERS)
          .then(res => res.data.banners);

        const carousel = await axios
          .get(URLS.GET_CAROUSEL)
          .then(res => res.data.carousel);
          
          
        setBooksData(books);
        setProductsData(products);
        setBannersData(banners);
        setCarouselData(carousel);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      getData();
      window.scrollTo(0, 0);
    }, []);

    const handleSlideChange = (index: number) => {
      setActiveIndex(index);
    };

    const renderHeader = (): JSX.Element => {
      return <components.Header burger={true} basket={true} line={true} />;
    };






  const renderCarousel = (): JSX.Element => {
      return (
          <>
              <div style={{ marginBottom: 22, position: 'relative' }}>
                   <Carousel
                    // KEY 1: Must be true for seamless wrap-around sliding
                    infiniteLoop={true} 
                    
                    // KEY 2: Sets the smooth animation duration for ALL slides
                    transitionTime={500} 
                    
                  

                    showStatus={false}
                    showThumbs={false}
                    showIndicators={false}
                    selectedItem={activeIndex}
                    onChange={handleSlideChange}
                    swipeable={true}
                    emulateTouch={true}
                    
                    // Custom arrows use the internal infiniteLoop logic
                    renderArrowPrev={(onClickHandler, hasPrev, label) =>
                        hasPrev && (
                            <button
                                type="button"
                                onClick={onClickHandler}
                                title={label}
                                style={{
                                    position: 'absolute',
                                    zIndex: 2,
                                    top: 'calc(50% - 20px)',
                                    left: 10,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: 40,
                                    height: 40,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <ChevronLeft color="#fff" />
                            </button>
                        )
                    }
                    renderArrowNext={(onClickHandler, hasNext, label) =>
                        hasNext && (
                            <button
                                type="button"
                                onClick={onClickHandler}
                                title={label}
                                style={{
                                    position: 'absolute',
                                    zIndex: 2,
                                    top: 'calc(50% - 20px)',
                                    right: 10,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: 40,
                                    height: 40,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <ChevronRight color="#fff" />
                            </button>
                        )
                    }
                >
                    {carouselData?.map((item: any, index: number) => (
                        <div
                            key={index}
                            onClick={() => {
                                if (!item.link) return;

                                if (item.link.startsWith('http')) {
                                    window.open(item.link, '_blank');
                                } else {
                                    navigate(item.link);
                                }
                            }}
                            style={{ cursor: item.link ? 'pointer' : 'default' }}
                        >
                            <img
                                src={item.image}
                                alt='Carousel'
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: isMobile ? 1000 : 400,
                                    objectFit: 'cover',
                                    backgroundColor: theme.colors.imageBackground,
                                    display: 'block'
                                }}
                                className="carousel-img"
                            />
                        </div>
                    ))}
                </Carousel>
              </div>
          </>
      );
  };


    const renderIndicator = (): JSX.Element => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
          }}
        >
          {carouselData?.map((item: any, index: number) => {
            const isSelected = index === activeIndex;
            const indicatorStyle = {
              background: isSelected ? theme.colors.mainColor : '#E8EFF4',
              display: 'inline-block',
              width: 22,
              height: 6,
              margin: '0 6px',
              borderRadius: 6,
            };
            return <div style={indicatorStyle} key={index} />;
          })}
        </div>
      );
    };
    

    const renderBestSellers = (): JSX.Element => {
      return (
        <div style={{marginBottom: 20, display: 'flex', flexDirection: 'column'}}>
          <components.BlockHeading
            title='Magazines'
            containerStyle={{
              padding: '0 20px 0',
              marginBottom: 14,
            }}
            viewAllOnClick={() => {
              dispatch(actions.resetFilters());
              navigate('/Shop', {
                state: {products: productsData, title: 'Magazine'},
              });
            }}
          />
          <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20 ,}}>
            {productsData?.map((item: any, index: number, arra: any) => {
              const isLast = index === arra.length - 1;
              return (
                <items.ProductCard
                  key={item.id}
                  isLast={isLast}
                
                  item={{ ...item, price: undefined }} 
                  version={1}
                />
              );
            })}
          </custom.ScrollView>
        </div>
      );
    };

      const renderBooksSellers = (): JSX.Element => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column'}}>
          <components.BlockHeading
            title='Books'
            containerStyle={{
              padding: '0 20px 0',
              marginBottom: 14,
            }}
            viewAllOnClick={() => {
              dispatch(actions.resetFilters());
              navigate('/Shop', {
                state: {products:booksData, title: 'Books'},
              });
            }}
          />
          <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
            {booksData?.map((item: any, index: number, arra: any) => {
              const isLast = index === arra.length - 1;
              return (
                <items.ProductCard
                  key={item.id}
                  isLast={isLast}
                item={{ ...item, price: undefined }} 
                  version={1}
                />
              );
            })}
          </custom.ScrollView>
        </div>
      );
    };

    const renderBanner = (): JSX.Element => {
      const banner =
        bannersData && bannersData?.length > 0 ? bannersData[0]?.image : '';

      const matches = Array.isArray(productsData)
        ? productsData.filter(
            (product: any) => product.promotion === bannersData[0]?.promotion,
          )
        : [];
      return (
        <div style={{marginBottom: 40, display: 'flex'}}>
          <button
            onClick={() => {
              dispatch(actions.resetFilters());
              navigate('/Shop', {state: {products: matches}});
            }}
          >
            <img
              src={banner}
              alt='Banner'
              style={{
                width: '100%',
              }}
            />
          </button>
        </div>
      );
    };

    const renderFeatured = (): JSX.Element => {
      return (
        <div style={{marginBottom: 40, display: 'flex', flexDirection: 'column'}}>
          <components.BlockHeading
            title='Featured products'
            containerStyle={{
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: 14,
            }}
            viewAllOnClick={() => {
              dispatch(actions.resetFilters());
              navigate('/Shop', {state: {products: productsData}});
            }}
          />
          <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
            {productsData?.map((item: any, index: number, arra: any) => {
              const isLast = index === arra.length - 1;
              return (
                <items.ProductCard
                  key={item.id}
                  isLast={isLast}
                  item={item}
                  version={3}
                />
              );
            })}
          </custom.ScrollView>
        </div>
      );
    };

    const renderContent = () => {
      if (loading) return <components.TabLoader />;

      return (
          <div style={{  maxWidth: 1200, margin: '0px auto', width: '100%', paddingBottom: 64}}> 
        <main style={{display: 'flex', flexDirection: 'column'}}>
        
            {renderCarousel()}
            {renderIndicator()}
            {renderBestSellers()}
            {renderBooksSellers()}
            {/* {renderBanner()} */}
            {/* {renderFeatured()} */}
        </main>
        
        </div>
      );
    };

    const renderBottomTabBar = () => {
      return <components.BottomTabBar />;
    };

    return (
      <>
      

        {renderHeader()}
        {renderContent()}
        {renderBottomTabBar()}

      </> 
    );
  };
